import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';
import '../../styles/VisionMission.css';

function VisionMission() {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › About Us › Vision &amp; Mission</p>
                <h1>Vision &amp; Mission</h1>
                <p>Our guiding principles and institutional commitments</p>
            </div>
            <div className="page-content">
                <div className="vm-cards">
                    <div className="vm-card vision">
                        <div className="vm-icon">🎯</div>
                        <h2>Our Vision</h2>
                        <p>
                            To be a premier institution of higher learning that empowers students from all walks of life — especially rural and semi-urban communities — with quality education, strong values, and practical skills to excel in a rapidly changing world.
                        </p>
                    </div>
                    <div className="vm-card mission">
                        <div className="vm-icon">🚀</div>
                        <h2>Our Mission</h2>
                        <ul>
                            <li>To provide affordable and accessible quality higher education to all students irrespective of their socio-economic background.</li>
                            <li>To foster critical thinking, creativity, and ethical values among students.</li>
                            <li>To strengthen research, innovation, and community outreach through academic programs.</li>
                            <li>To develop well-rounded individuals equipped for professional excellence and responsible citizenship.</li>
                            <li>To maintain the highest standards of governance, transparency, and institutional integrity.</li>
                        </ul>
                    </div>
                </div>
                <div className="info-card" style={{ marginTop: '1.5rem' }}>
                    <h2>Core Values</h2>
                    <div className="cards-grid">
                        {[
                            { icon: '📚', title: 'Academic Excellence', desc: 'Commitment to rigorous learning and intellectual growth.' },
                            { icon: '🤝', title: 'Inclusivity', desc: 'Education for all, regardless of background or ability.' },
                            { icon: '💡', title: 'Innovation', desc: 'Encouraging creative thinking and new ideas.' },
                            { icon: '🌱', title: 'Social Responsibility', desc: 'Building students who contribute positively to society.' },
                            { icon: '⚖️', title: 'Integrity', desc: 'Upholding honesty and ethical conduct at every level.' },
                            { icon: '🌍', title: 'Sustainability', desc: 'Environment-conscious practices on campus and beyond.' },
                        ].map(v => (
                            <div className="grid-card" key={v.title}>
                                <div style={{ fontSize: '1.8rem', marginBottom: '0.4rem' }}>{v.icon}</div>
                                <h3>{v.title}</h3>
                                <p>{v.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default VisionMission;
